export const MAIL_EDITOR_CONTAINER_CLASS = 'editor-container';
export const MAIL_EDITOR_CONTAINER_EDM_CLASS = 'editor-container-edm';
